import React, { useEffect, useState, useCallback } from "react";
import { Slider } from "antd";
import { useRouter } from "next/router";

import styles from "../../styles/sass/search.module.scss";

const SelectCapacityScreen = (props) => {
  const { asPath } = useRouter();
  const [capacity, setCapacity] = useState("");
  const [slidepage, setSlidePage] = useState(false);

  const onNext = useCallback(
    (i) => {
      (capacity || i) && props.onNext(`${asPath}&capacity=${capacity || i}`);
    },
    [capacity, props, asPath]
  );

  useEffect(() => {
    setTimeout(() => setSlidePage(true), 700);
  }, []);


  return (
    <>
      <div
        className={`${styles["bk_o_cb"]} ${
          capacity ? styles["scs_i"] : styles["scs_nd_i"]
        }`}
      >
        <div
          className={`${styles["bk_i_cb"]} ${
            slidepage ? styles["bk_add_animation"] : ""
          }`}
        >
          <div className={`mc_container ${styles["bk_c_c_cb"]}`}>
            <div
              className={`${styles["bk_txt_cb"]} ${styles["spacerCapacity"]}`}
            >
              <h1 className={styles["title"]}>For how many people?</h1>
            </div>
            <div className={styles["d_c_b_m_d"]}>
              {[...new Array(20)].map((_, i) => (
                <span
                  className={
                    capacity && capacity > 0 && capacity === i + 1
                      ? styles["active"]
                      : ""
                  }
                  key={i}
                  onClick={() => onNext(i + 1)}
                >
                  {i + 1}
                </span>
              ))}
              <span
                onClick={() => setCapacity(21)}
                className={capacity && capacity > 20 ? styles["active"] : ""}
              >
                20+
              </span>
            </div>

            {capacity > 20 && (
              <div className={styles["slider-container"]}>
                <p>
                  Custom desks number<span>({capacity > 20 && capacity})</span>
                </p>
                <Slider
                  className={`${capacity > 20 ? styles["active"] : ""}`}
                  min={21}
                  max={100}
                  defaultValue={21}
                  onChange={setCapacity}
                />
                <span className={styles["ok-btn"]} onClick={onNext}>
                  Ok
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <span className="backPage" onClick={props?.onBack}>Back</span>
    </>
  );
};

export default SelectCapacityScreen;
